// libraries
import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
// commons
import CONSTANSTS from "../../common/constansts";
//component
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";
import IconUpload from "../../assets/images/pages/icon-upload.png";
import AppCustomToast, { PageContext } from "components/app-custom-toast";

const PageMerchantAdd = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const history = useHistory();
  //const [categoryList, setCategoryList] = useState(undefined);
  const [stateList, setStateList] = useState(undefined);
  const [bankList, setBankList] = useState(undefined);
 // const [hqList, setHqList] = useState(undefined);
  let token = localStorage.getItem("@storage_token");

  useEffect(() => {
    // const fetchCategory = async () => {
    //   fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "MERCHANT_CATEGORY", {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((json) => {
    //       let res = json.result;
    //       setCategoryList(res);
    //     });
    // };
    const fetchState = async () => {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "STATE", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          let res = json.result;
          setStateList(res);
        });
    };
    const fetchBank = async () => {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION + "BANK", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          let res = json.result;
          setBankList(res);
        });
    };
    // const fetchHeadquarters = async () => {
    //   fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MAIN_MERCHANT_LIST, {
    //     method: "GET",
    //     headers: {
    //       // "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //       Authorization: "Bearer " + token
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((json) => {
    //       let res = json.result;
    //       setHqList(res);
    //     });
    // };
    // const fetchHeadquarters = async () => {
    //   fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_MAIN_MERCHANT_LIST, {
    //     method: "GET",
    //     headers: {
    //       // "Content-Type": "application/json",
    //       Accept: "*/*",
    //       "Accept-language": "en", "X-DEVICE-OS": "Web",
    //       Authorization: "Bearer " + token
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((json) => {
    //       let res = json.result;
    //       setHqList(res);
    //     });
    // };
    //fetchCategory();
    fetchState();
    fetchBank();
    // fetchHeadquarters();
  }, []);

  const inputText = {
    merchantName: {
      placeholder: "Merchant Name",
      required: "Merchant Name required",
      invalid: "Invalid merchant name",
      regex: /^[a-zA-Z0-9 .&/()-]*$/,
    },
    merchantEmail: {
      placeholder: "Email",
      required: "Email required",
      invalid: "Invalid email",
      regex: CONSTANSTS.REGEX.email,
    },
    category: {
      placeholder: "Category",
      required: "Category required",
      invalid: "Invalid category",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    otherCategory: {
      placeholder: "Category Name",
      required: "Category Name required",
      invalid: "Invalid category name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address1: {
      placeholder: "Address 1",
      required: "Address 1 required",
      invalid: "Invalid address 1",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    address2: {
      placeholder: "Address 2",
      required: "Address 2 required",
      invalid: "Invalid address 2",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    state: {
      placeholder: "State",
      required: "State required",
      invalid: "Invalid state",
      regex: /^.{5,}$/,
    },
    bankName: {
      placeholder: "Bank Name",
      required: "Bank Name required",
      invalid: "Invalid bank name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    accountName: {
      placeholder: "Account Name",
      required: "Account Name required",
      invalid: "Invalid account name",
      regex: /^[a-zA-Z0-9 .&/()-]*$/,
    },
    effectiveDate: {
      placeholder: "Effective Date",
      required: "Effective Date required",
      invalid: "Invalid effective date",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    agreementUpload: {
      placeholder: "No file chosen",
      required: "Agreement Upload required",
      invalid: "Invalid agreement upload",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    city: {
      placeholder: "City",
      required: "City required",
      invalid: "Invalid city",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    businessRegNo: {
      placeholder: "Business Registration Number",
      required: "Business Reg. No required",
      invalid: "Invalid Business Reg. No",
      regex: /^[a-zA-Z0-9 ()-]*$/,
    },
    hqEmail: {
      placeholder: "Headquarters Email",
      required: "Headquarters Email required",
      invalid: "Invalid headquarters email",
      regex: CONSTANSTS.REGEX.email,
    },
  };

  const inputField = {
    merchantName: {
      value: "",
      error: "",
    },
    merchantEmail: {
      value: "",
      error: "",
    },
    mobilePhone: {
      value: "",
      error: "",
    },
    category: {
      value: "",
      error: "",
    },
    otherCategory: {
      value: "",
      error: "",
    },
    address1: {
      value: "",
      error: "",
    },
    address2: {
      value: "",
      error: "",
    },
    state: {
      value: "",
      error: "",
    },
    bankName: {
      value: "",
      error: "",
    },
    accountName: {
      value: "",
      error: "",
    },
    effectiveDate: {
      value: "",
      error: "",
    },
    agreementUpload: {
      value: "",
      error: "",
    },
    city: {
      value: "",
      error: "",
    },
    businessRegNo: {
      value: "",
      error: "",
    },
    subsidiary: {
      value: false,
      error: "",
    },
    hqEmail: {
      value: "",
      error: "",
    }
  };

  const inputNum = {
    mobilePhone: {
      placeholder: "Mobile Phone",
      required: "Mobile Phone required",
      invalid: "Invalid mobile phone",
      regex: /^.{10,}$/,
    },
    postcode: {
      placeholder: "Postcode",
      required: "Postcode required",
      invalid: "Invalid Postcode",
      regex: /^.{5,}$/,
    },
    accountNo: {
      placeholder: "Account No",
      required: "Account No required",
      invalid: "Invalid Account No",
      regex: /^.{7,}$/,
    },
  };

  const numberField = {
    mobilePhone: {
      value: "",
      error: "",
    },
    postcode: {
      value: "",
      error: "",
    },
    accountNo: {
      value: "",
      error: "",
    },
  };

  const [input, setInput] = useState(inputField);
  const [numField, setNumField] = useState(numberField);

  const back = async () => {
    history.push(pathnames.pageMerchantList);
  };

  const [disableBtn, setDisableBtn] = useState(false);

  // const getInputClassName = (error) => {
  //   const classNames = ["merchant-input-text"];
  //   if (error!==null) {
  //       classNames.push("merchant-input-text--error");
  //   }
  // };

  const [nameValidate, setNameValidate] = useState("merchant-input-text");
  const [emailValidate, setEmailValidate] = useState("merchant-input-text");
 // const [categoryValidate, setCategoryValidate] = useState("merchant-input-select merchant-input-select__input");
  const [otherCategoryValidate, setOtherCategoryValidate] = useState("merchant-input-text");
  const [address1Validate, setAddress1Validate] = useState("text-area");
  const [cityValidate, setCityValidate] = useState("merchant-input-text");
  const [stateValidate, setStateValidate] = useState("merchant-input-select merchant-input-select__input");
  const [bankNameValidate, setBankNameValidate] = useState("merchant-input-select merchant-input-select__input");
  const [hqEmailValidate, setHqEmailValidate] = useState("merchant-input-text");
  const [accountNameValidate, setAccountNameValidate] = useState("merchant-input-text");
  const [effectiveDateValidate, setEffectiveDateValidate] = useState("merchant-input-text");
  const [agreementUploadValidate, setAgreementUploadValidate] = useState("merchant-input-text");
  const [mobilePhoneValidate, setMobilePhoneValidate] = useState("merchant-input-text");
  const [postcodeValidate, setPostcodeValidate] = useState("merchant-input-text");
  const [accountNoValidate, setAccountNoValidate] = useState("merchant-input-text");
  const [businessRegNoValidate, setBusinessRegNoValidate] = useState("merchant-input-text");

  const createNewMerchant = () => {

    checkValidation();

    if (
      nameValidate            === "merchant-input-text" && inputText.merchantName.regex.test(input.merchantName.value) === true &&
      emailValidate           === "merchant-input-text" && input.merchantEmail.value !== "" && CONSTANSTS.REGEX.email.test(input.merchantEmail.value) === true &&
     // categoryValidate        === "merchant-input-select merchant-input-select__input" && input.category.value !== "" &&
      otherCategoryValidate   === "merchant-input-text" && input.otherCategory.value !== "" &&
      address1Validate        === "text-area"           && input.address1.value !== "" &&
      cityValidate            === "merchant-input-text" && input.city.value     !== "" &&
      stateValidate           === "merchant-input-select merchant-input-select__input" && input.state.value    !=="" &&
      bankNameValidate        === "merchant-input-select merchant-input-select__input" && input.bankName.value !=="" &&
      hqEmailValidate         === "merchant-input-text" && (input.subsidiary.value ? input.hqEmail.value !=="" : true) &&
      accountNameValidate     === "merchant-input-text" && input.accountName.value    !== "" && inputText.accountName.regex.test(input.accountName.value) &&
      effectiveDateValidate   === "merchant-input-text" && input.effectiveDate.value  !== "" &&
      agreementUploadValidate === "merchant-input-text" && file                       !== undefined &&
      mobilePhoneValidate     === "merchant-input-text" && numField.mobilePhone.value !== "" && inputNum.mobilePhone.regex.test(numField.mobilePhone.value) === true &&
      postcodeValidate        === "merchant-input-text" && numField.postcode.value    !== "" && inputNum.postcode.regex.test(numField.postcode.value) === true &&
      accountNoValidate       === "merchant-input-text" && numField.accountNo.value   !== "" && inputNum.accountNo.regex.test(numField.accountNo.value) === true &&
      businessRegNoValidate   === "merchant-input-text" && input.businessRegNo.value  !== "" && inputText.businessRegNo.regex.test(input.businessRegNo.value) === true
    ) {
     setDisableBtn(true);
      setTimeout(() => {
        setDisableBtn(false);
      }, 6000);

      // let token = null;
      // token = localStorage.getItem("@storage_token");
      let date = "";
      date = input.effectiveDate.value;

      const formData = new FormData();
      formData.append("agreementDocument", file);
      formData.append("address1", input.address1.value.trim());
      formData.append("address2", input.address2.value.trim());
      formData.append("bankAccName", input.accountName.value.trim());
      formData.append("bankAccNumber", numField.accountNo.value);
      formData.append("bankCode", input.bankName.value);
      formData.append("category",  input.otherCategory.value.trim());
      formData.append("city", input.city.value.trim());
      formData.append("effectiveDate", date.substring(10, 8) + "/" + date.substring(7, 5) + "/" + date.substring(0, 4));
      formData.append("name", input.merchantName.value.trim());
      formData.append("postcode", numField.postcode.value);
      formData.append("state", input.state.value);
      formData.append("email", input.merchantEmail.value);
      formData.append("mobileNumber", numField.mobilePhone.value);
      formData.append("businessRegNo", input.businessRegNo.value.toUpperCase());
      formData.append("mainMerchantName", null);
      formData.append("hqEmail", input.hqEmail.value);

      // fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/create", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.CREATE_MERCHANT, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          const response = data;
          console.log(response);
          if (response.responseCode === 200) {
            messageDialog({
              isOpen: true,
              condition: CONSTANSTS.DIALOG.success,
              title: CONSTANSTS.DIALOG_TITLE.general_success,
              message: CONSTANSTS.DIALOG_MESSAGE.merchant_add_successful,
              defaultOnClick: false
            });
            history.push(pathnames.pageMerchantList)
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: response.message, defaultOnClick: false });
          }
        });
    } else {
      return;
    }
  };

  const onHandleOnChange = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    setInput({
      ...input,
      [name]: {
        ...input[name],
        error: errorMessage(name, value),
        value: value,
      },
    });

    checkEmpty(name, value);

  };

  const onHandleCheckbox = () => {
    setInput({
      ...input,
      subsidiary: {
        value: !input.subsidiary.value,
        error: ""
      }
    })
  }

  // const onSearch = (searchTerm) => {
  //   setInput({
  //     ...input,
  //     headquarters: {
  //       value: searchTerm,
  //       error: errorMessage('headquarters', searchTerm),
  //     }
  //   })
  // };

  const checkEmpty = (name,value) => {
    // console.log(name, value)
    if(name === "merchantName"){
      if(value === ""){
        setNameValidate("merchant-input-text-error");
      } else {
        setNameValidate("merchant-input-text");
      }
    }
    if(name === "merchantEmail"){
      if(value === ""){
        setEmailValidate("merchant-input-text-error");
      } else {
        setEmailValidate("merchant-input-text");
      }
    }
    if(name === "mobilePhone"){
      if(value === ""){
        setMobilePhoneValidate("merchant-input-text-error");
      } else {
        setMobilePhoneValidate("merchant-input-text");
      }
    }
    // if(name === "category"){
    //   if(value === ""){
    //     setCategoryValidate("merchant-input-select-error merchant-input-select-error__input");
    //   } else {
    //     setCategoryValidate("merchant-input-select merchant-input-select__input");
    //   }
    // }
    if(name === "otherCategory"){
      if(value === ""){
        setOtherCategoryValidate("merchant-input-text-error");
      } else {
        setOtherCategoryValidate("merchant-input-text");
      }
    }
    if(name === "address1"){
      if(value === ""){
        setAddress1Validate("text-area-error");
      } else {
        setAddress1Validate("text-area");
      }
    }
    if(name === "city"){
      if(value === ""){
        setCityValidate("merchant-input-text-error");
      } else {
        setCityValidate("merchant-input-text");
      }
    }
    if(name === "postcode"){
      if(value === ""){
        setPostcodeValidate("merchant-input-text-error");
      } else {
        setPostcodeValidate("merchant-input-text");
      }
    }
    if(name === "state"){
      if(value === ""){
        setStateValidate("merchant-input-select-error merchant-input-select-error__input");
      } else {
        setStateValidate("merchant-input-select merchant-input-select__input");
      }
    }
    if(name === "bankName"){
      if(value === ""){
        setBankNameValidate("merchant-input-select-error merchant-input-select-error__input");
      } else {
        setBankNameValidate("merchant-input-select merchant-input-select__input");
      }
    }
    if(name === "accountName"){
      if(value === ""){
        setAccountNameValidate("merchant-input-text-error");
      } else {
        setAccountNameValidate("merchant-input-text");
      }
    }
    if(name === "accountNo"){
      if(value === ""){
        setAccountNoValidate("merchant-input-text-error");
      } else {
        setAccountNoValidate("merchant-input-text");
      }
    }
    if(name === "effectiveDate"){
      if(value === ""){
        setEffectiveDateValidate("merchant-input-text-error");
      } else {
        setEffectiveDateValidate("merchant-input-text");
      }
    }
    if(name === "file-input"){
      if(value === undefined || value === null || value === ""){
        setAgreementUploadValidate("merchant-input-text-error");
      } else {
        setAgreementUploadValidate("merchant-input-text");
      }
    }
    if(name === "businessRegNo"){
      if(value === ""){
        setBusinessRegNoValidate("merchant-input-text-error");
      } else {
        setBusinessRegNoValidate("merchant-input-text");
      }
    }
    if(name === "hqEmail" && input.subsidiary.value){
      if(value === ""){
        setHqEmailValidate("merchant-input-text-error");
      } else {
        setHqEmailValidate("merchant-input-text");
      }
    }
  }

  const checkValidation = () =>{
    const nameValidate = inputText.merchantName.regex.test(input.merchantName.value) && CONSTANSTS.REGEX.checkEmpty.test(input.merchantName.value);
    if (nameValidate === false && input.merchantName.value === "") {
      setNameValidate("merchant-input-text-error");
    } else {
      setNameValidate("merchant-input-text");
    }
    const emailValidate = CONSTANSTS.REGEX.email.test(input.merchantEmail.value) && CONSTANSTS.REGEX.checkEmpty.test(input.merchantEmail.value);
    if (emailValidate === false && input.merchantEmail.value === "") {
      setEmailValidate("merchant-input-text-error");
    } else {
      setEmailValidate("merchant-input-text");
    }
    // const categoryValidate = CONSTANSTS.REGEX.checkEmpty.test(input.category.value);
    // if (categoryValidate === false) {
    //   setCategoryValidate("merchant-input-select-error merchant-input-select-error__input");
    // } else {
    //   setCategoryValidate("merchant-input-select merchant-input-select__input");
    // }
    const otherCategoryValidate = CONSTANSTS.REGEX.checkEmpty.test(input.otherCategory.value);
    if (otherCategoryValidate === false && input.otherCategory.value === "") {
      setOtherCategoryValidate("merchant-input-text-error");
    } else {
      setOtherCategoryValidate("merchant-input-text");
    }
    const address1Validate = CONSTANSTS.REGEX.checkEmpty.test(input.address1.value);
    if (address1Validate === false) {
      setAddress1Validate("text-area-error");
    } else {
      setAddress1Validate("text-area");
    }
    const cityValidate = CONSTANSTS.REGEX.checkEmpty.test(input.city.value);
    if (cityValidate === false && input.city.value === "") {
      setCityValidate("merchant-input-text-error");
    } else {
      setCityValidate("merchant-input-text");
    }
    const stateValidate = CONSTANSTS.REGEX.checkEmpty.test(input.state.value);
    if (stateValidate === false) {
      setStateValidate("merchant-input-select-error merchant-input-select-error__input");
    } else {
      setStateValidate("merchant-input-select merchant-input-select__input");
    }
    const bankNameValidate = CONSTANSTS.REGEX.checkEmpty.test(input.bankName.value);
    if (bankNameValidate === false) {
      setBankNameValidate("merchant-input-select-error merchant-input-select-error__input");
    } else {
      setBankNameValidate("merchant-input-select merchant-input-select__input");
    }
    const accountNameValidate = inputText.accountName.regex.test(input.accountName.value) && CONSTANSTS.REGEX.checkEmpty.test(input.accountName.value);
    if (accountNameValidate === false && input.accountName.value === "") {
      setAccountNameValidate("merchant-input-text-error");
    } else {
      setAccountNameValidate("merchant-input-text");
    }
    const effectiveDateValidate = CONSTANSTS.REGEX.checkEmpty.test(input.effectiveDate.value);
    if (effectiveDateValidate === false && input.effectiveDate.value === "") {
      setEffectiveDateValidate("merchant-input-text-error");
    } else {
      setEffectiveDateValidate("merchant-input-text");
    }
    const agreementUploadValidate = file !== undefined;
    if (agreementUploadValidate === false) {
      setAgreementUploadValidate("merchant-input-text-error");
    } else {
      setAgreementUploadValidate("merchant-input-text");
    }

    const mobilePhoneValidate = inputNum.mobilePhone.regex.test(numField.mobilePhone.value) && CONSTANSTS.REGEX.checkEmpty.test(input.accountName.value);
    if (mobilePhoneValidate === false && numField.mobilePhone.value === "") {
      setMobilePhoneValidate("merchant-input-text-error");
    } else {
      setMobilePhoneValidate("merchant-input-text");
    }
    const postcodeValidate = CONSTANSTS.REGEX.checkEmpty.test(numField.postcode.value) && inputNum.postcode.regex.test(numField.postcode.value);
    if (postcodeValidate === false && numField.postcode.value === "") {
      setPostcodeValidate("merchant-input-text-error");
    } else {
      setPostcodeValidate("merchant-input-text");
    }
    const accountNoValidate = inputNum.accountNo.regex.test(numField.accountNo.value);
    if (accountNoValidate === false && numField.accountNo.value === "") {
      setAccountNoValidate("merchant-input-text-error");
    } else {
      setAccountNoValidate("merchant-input-text");
    }
    const bussinessRegNoValidate = CONSTANSTS.REGEX.checkEmpty.test(input.businessRegNo.value);
    if (bussinessRegNoValidate === false && input.businessRegNo.value === "") {
      setBusinessRegNoValidate("merchant-input-text-error");
    } else {
      setBusinessRegNoValidate("merchant-input-text");
    }
    const hqEmailValidate = CONSTANSTS.REGEX.email.test(input.hqEmail.value) && CONSTANSTS.REGEX.checkEmpty.test(input.hqEmail.value);
    if (hqEmailValidate === false && input.subsidiary.value) {
      setHqEmailValidate("merchant-input-text-error");
    } else {
      setHqEmailValidate("merchant-input-text");
    }
  }

  const errorMessage = (name, value) => {
    if (!inputText || !value) {
      return inputText[name].required;
    } else if (!inputText[name].regex.test(value)) {
      return inputText[name].invalid;
    } else {
      return "";
    }
  };

  const errorMessage1 = (name, value) => {
    if (!value) {
      return inputNum[name].required;
    } else if (!inputNum[name].regex.test(value)) {
      return inputNum[name].invalid;
    } else {
      return "";
    }
  };

  const onHandleOnChangeNum = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    setNumField({
      ...numField,
      [name]: {
        ...numField[name],
        error: errorMessage1(name, value),
        value: value.replace(/\D/, ""),
      },
    });

    checkEmpty(name, value);
  };

  // const onHandleOnBlur = (event) => {
  //   const name = event.currentTarget.name;
  //   const value = event.currentTarget.value;

  //   // setNumField({
  //   //   ...numField,
  //   //   [name]: {
  //   //     ...numField[name],
  //   //     error: "errorMessage(name, value)",
  //   //     value: value.replace(CONSTANSTS.REGEX.space, ""),
  //   //   },
  //   // });
  // };

  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [exceedFileSize, setExceedFileSize] = useState("");
  const handleFileChange = (event) => {
    let inputFile = event.target.files[0];
    // console.log("->", inputFile);
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    checkEmpty(name, value)

    // check file size
    // https://stackoverflow.com/questions/33531140/get-file-size-in-mb-or-kb?msclkid=389800bbb70111ec8058dc0ac41435f5
    var _size = inputFile.size;
    var fSExt = new Array("Bytes", "KB", "MB", "GB"),
      i = 0;
    while (_size > 900) {
      _size /= 1024;
      i++;
    }
    var num = Math.round(_size * 100) / 100;
    var exactSize = num + " " + fSExt[i];
    console.log("FILE SIZE = ", exactSize);

    if (i > 2) {
      // GB
      setExceedFileSize("Uploaded file or image cannot exceed 5 MB");
    } else if (i === 2 && num > 5) {
      // exceed 500 MB
      setExceedFileSize("Uploaded file or image cannot exceed 5 MB");
    } else {
      setFile(inputFile);
      setFileName(inputFile.name.toString());
    }

    // setFile(inputFile);
    // setFileName(inputFile.name.toString());
  };

  const inputFile = useRef();

  const openFile = () => {
    inputFile.current.click();
  };

  return (
    <div className="page-merchant-add">
      <div className="top-context" style={{ padding: "0px 50px 30px 50px" }}>
        <div className="title">Add New Merchant</div>
        <div className="search-button">
          <AppButton colorType="orange" label="Cancel" onClick={back}></AppButton>
        </div>
        <div className="search-long-button">
          <button className="long-button" onClick={createNewMerchant} disabled={disableBtn}>
            {/* <button className="long-button" onClick={createNewMerchant}> */}
            Add New Merchant
          </button>
        </div>
      </div>

      <div className="page-home-page">
        <div className="home-page">
          <div className="input-field">
            <div className="row top-padding">
              <div className="cards">
                <div className="card">
                  <div className="grid">
                    <div>Merchant Name</div>
                    <div className="merchant-input">
                      <input type="text" className={nameValidate} name="merchantName" value={input.merchantName.value} onChange={onHandleOnChange} required={true} maxLength={50} />
                      <p className="app-auth-input__error">{input.merchantName.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Merchant Email</div>
                    <div className="merchant-input">
                      <input type="text" className={emailValidate} name="merchantEmail" value={input.merchantEmail.value} onChange={onHandleOnChange} />
                      <p className="app-auth-input__error">{input.merchantEmail.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Mobile Phone</div>
                    <div className="merchant-input">
                      <input type="text" className={mobilePhoneValidate} name="mobilePhone" value={numField.mobilePhone.value} onChange={onHandleOnChangeNum} maxLength={11} />
                      <p className="app-auth-input__error">{numField.mobilePhone.error}</p>
                    </div>
                  </div>
                  {/* <div className="grid">
                    <div>Category</div>
                    <div className="merchant-input">
                      {categoryList !== undefined ? (
                        <select name="category" id="category" className={categoryValidate} style={{ textAlign: "left" }} value={input.category.value} onChange={onHandleOnChange}>
                          <option value="">
                            -- Category --
                          </option>
                          {categoryList
                            .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                            .map((d, i) => (
                              <option value={d.code} key={i}>
                                {d.label}
                              </option>
                            ))}
                            <option value={"other"}>
                                Other
                              </option>
                        </select>
                      ) : (
                        <select name="category" id="category" className={categoryValidate} style={{ textAlign: "left" }} value={input.category.value} onChange={onHandleOnChange}>
                          <option value="" >
                            -- Category --
                          </option>
                        </select>
                      )}
                      <p className="app-auth-input__error">{input.category.error}</p>
                    </div>
                  </div> */}
                   
                    <div className="grid">
                      <div>Category Name</div>
                      <div className="merchant-input">
                        <input type="text" className={otherCategoryValidate} name="otherCategory" value={input.otherCategory.value} onChange={onHandleOnChange} />
                        <p className="app-auth-input__error">{input.otherCategory.error}</p>
                      </div>
                    </div>
                 
                  <div className="grid">
                    <div style={{ height: "110px" }}>Address 1</div>
                    <div className="merchant-input">
                      <textarea name="address1" id="address1" cols="41" rows="3" className={address1Validate} value={input.address1.value} onChange={onHandleOnChange} maxLength={100}></textarea>
                      <p className="app-auth-input__error">{input.address1.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div style={{ height: "110px" }}>Address 2</div>
                    <div className="merchant-input">
                      <textarea name="address2" id="address2" cols="41" rows="3" className="text-area" value={input.address2.value} onChange={onHandleOnChange} maxLength={100}></textarea>
                    </div>
                  </div>
                  <div className="grid">
                    <div>City / Town</div>
                    <div className="merchant-input">
                      <input type="text" className={cityValidate} name="city" value={input.city.value} onChange={onHandleOnChange} maxLength={50} />
                      <p className="app-auth-input__error">{input.city.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Postcode</div>
                    <div className="merchant-input">
                      <input type="text" className={postcodeValidate} name="postcode" value={numField.postcode.value} onChange={onHandleOnChangeNum} maxLength={5} />
                      <p className="app-auth-input__error">{numField.postcode.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>State</div>
                    <div className="merchant-input">
                      {stateList !== undefined ? (
                        <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={input.state.value} onChange={onHandleOnChange}>
                          <option value="" >
                            -- State --
                          </option>
                          {stateList
                            .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                            .map((d, i) => (
                              <option value={d.code} key={i}>
                                {d.label}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select name="state" id="state" className={stateValidate} style={{ textAlign: "left" }} value={input.state.value} onChange={onHandleOnChange}>
                          <option value="" >
                            -- State --
                          </option>
                        </select>
                      )}
                      <p className="app-auth-input__error">{input.state.error}</p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="grid">
                    <div>Subsidiary</div>
                    <div className="merchant-input">
                      <input
                        type="checkbox"
                        className="check-box"
                        id="subsidiary-button"
                        name="subsidiary"
                        checked={input.subsidiary.value}
                        onChange={onHandleCheckbox}
                      />
                      <p className="app-auth-input__error">{input.businessRegNo.error}</p>
                    </div>
                  </div>
                  {input.subsidiary.value &&
                <div className="grid">
                <div>Headquarters Email</div>
                <div className="merchant-input">
                  <input 
                    type="text" 
                    name="hqEmail" 
                    id="hqEmail" 
                    value={input.hqEmail.value} 
                    onChange={onHandleOnChange} 
                    className={hqEmailValidate} 
                    style={{ textAlign: "left" }} 
                    //readOnly={disableEditInputField || enableEditTab} 
                  />
                  <p className="app-auth-input__error">{input.hqEmail.error}</p>
                </div>
              </div>}
                <div className="grid">
                    <div>Business Reg. No</div>
                    <div className="merchant-input">
                      <input
                        type="text"
                        className={businessRegNoValidate}
                        name="businessRegNo"
                        value={input.businessRegNo.value}
                        onChange={onHandleOnChange}
                        // error={input.businessRegNo.error}
                        maxLength={24}
                      />
                      <p className="app-auth-input__error">{input.businessRegNo.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Bank Name</div>
                    <div className="merchant-input">
                      {bankList !== undefined ? (
                        <select id="bankName" className={bankNameValidate} name="bankName" style={{ textAlign: "left" }} value={input.bankName.value} onChange={onHandleOnChange}>
                          <option value="" >
                            -- Bank Name --
                          </option>
                          {bankList
                            .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                            .map((d, i) => (
                              <option value={d.code} key={i}>
                                {d.label}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select id="bankName" className={bankNameValidate} name="bankName" style={{ textAlign: "left" }} value={input.bankName.value} onChange={onHandleOnChange}>
                          <option value="" >
                            -- Bank Name --
                          </option>
                        </select>
                      )}
                      <p className="app-auth-input__error">{input.bankName.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Account Name</div>
                    <div className="merchant-input">
                      <input type="text" className={accountNameValidate} name="accountName" value={input.accountName.value} onChange={onHandleOnChange} maxLength={50} />
                      <p className="app-auth-input__error">{input.accountName.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div style={{ height: "110px" }}>Account No</div>
                    <div className="merchant-input" style={{ height: "110px" }}>
                      <input
                        type="text"
                        className={accountNoValidate}
                        name="accountNo"
                        value={numField.accountNo.value}
                        onChange={onHandleOnChangeNum}
                        // error={numField.accountNo.error}
                        maxLength={19}
                      />
                      <p className="app-auth-input__error">{numField.accountNo.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div style={{ height: "110px" }}>Effective Date</div>
                    <div className="merchant-input" style={{ height: "110px" }}>
                      <input type="date" className={effectiveDateValidate} name="effectiveDate" value={input.effectiveDate.value} onChange={onHandleOnChange} />
                      <p className="app-auth-input__error">{input.effectiveDate.error}</p>
                    </div>
                  </div>
                  <div className="grid">
                    <div>Agreement Upload</div>
                    <label htmlFor="file-input" style={{width:"420px"}}>
                      <div className="merchant-input" style={{ height: "110px" }}>
                        <input
                          type="text"
                          className={agreementUploadValidate}
                          name="agreementUpload"
                          placeholder={inputText.agreementUpload.placeholder}
                          value={fileName}
                          onChange={onHandleOnChange}
                          readOnly
                          onClick={openFile}
                        />
                        <p className="app-auth-input__error">{input.agreementUpload.error}</p>
                        <p className="app-auth-input__error">{exceedFileSize}</p>
                      </div>
                      <div style={{ position: "absolute", bottom: "210px", marginLeft: "382px" }}>
                        <img src={IconUpload} alt="upload icon" style={{ width: "30px", cursor: "pointer" }} />
                      </div>
                    </label>
                    <input type="file" name="file-input" id="file-input" ref={inputFile} accept="application/pdf, image/png, image/jpg, image/jpeg" style={{ display: "none" }} onChange={handleFileChange} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageMerchantAdd;
